import { HTMLAttributes } from "react";
import { cn } from "@/src/lib/utils";

interface ContainerProps extends HTMLAttributes<HTMLDivElement> {}

export function Container({ className, children, ...props }: ContainerProps) {
  return (
    <div
      className={cn(
        "mx-auto w-full max-w-max-width px-6 md:px-8 lg:px-10 xl:px-12",
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
}
